const TypeDto = {
	tesztlap_kepek: 'tesztlap képek',
	adatlap_kepek: 'adatlap képek'
};

export default TypeDto;
